module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc4-4868a159a0c67a79674adbf726f1cf5a.jpg";